export default __webpack_public_path__ + "static/media/medex-backdrop.8881538b.png";